import { initializeMetas } from "./metas/initialize.js";
import { registerInitialMetas } from "./metas/registerInitial.js";
import { initializeTransports } from "./transports/initialize.js";
import { initializeUnpatchedConsole } from "./unpatchedConsole/initialize.js";
import { initializeInternalLogger } from "./internalLogger/initialize.js";
import { registerInitialTransports } from "./transports/registerInitial.js";
import { initializeAPI } from "./api/initialize.js";
import { initializeInstrumentations } from "./instrumentations/initialize.js";
import { registerInitialInstrumentations } from "./instrumentations/registerInitial.js";
import { isInternalFaroOnGlobalObject } from "./sdk/internalFaroGlobalObject.js";
import { registerFaro } from "./sdk/registerFaro.js";
//#region src/initialize.ts
function initializeFaro(config) {
	const unpatchedConsole = initializeUnpatchedConsole(config);
	const internalLogger = initializeInternalLogger(unpatchedConsole, config);
	if (isInternalFaroOnGlobalObject() && !config.isolate) {
		internalLogger.error("Faro is already registered. Either add instrumentations, transports etc. to the global faro instance or use the \"isolate\" property");
		return;
	}
	internalLogger.debug("Initializing");
	const metas = initializeMetas(unpatchedConsole, internalLogger, config);
	const transports = initializeTransports(unpatchedConsole, internalLogger, config, metas);
	const api = initializeAPI(unpatchedConsole, internalLogger, config, metas, transports);
	const instrumentations = initializeInstrumentations(unpatchedConsole, internalLogger, config, metas, transports, api);
	const faro = registerFaro(unpatchedConsole, internalLogger, config, metas, transports, api, instrumentations);
	registerInitialMetas(faro);
	registerInitialTransports(faro);
	registerInitialInstrumentations(faro);
	return faro;
}
//#endregion
export { initializeFaro };

//# sourceMappingURL=initialize.js.map